module.exports = __webpack_public_path__ + "mo/img/piece-15.b9330e71.svg";